module.exports = __webpack_public_path__ + "img/nav-back.c400555f.svg";